import React from "react";
import Layout from "../../components/layout/index";
import PageContainer from "../../components/PageContainer";

import Hero from "../../components/home/Hero";
import Products from "../../components/home/Products";
import Leagues from "../../components/home/Leagues";
import Media from "../../components/media";
import NewsLetter from "../../components/home/Newletter";
import Blog from "../../components/home/Blog";
import Customers from "../../components/customers/Customers";

const PreLoginHome = () => {
  return (
    <PageContainer
      title="Private Company Data, PE & VC Deals in India | Venture Intelligence"
      description="Venture Intelligence is India’s leading platform for private company data - PE & VC deals, M&A transactions and detailed financials."
    >

    <Layout>
      <Hero />
      <Products />
      {/* <Leagues /> */}
      <Blog />
      {/* <NewsLetter /> */}
      {/* <Media /> */}
      <Customers />
    </Layout>

    </PageContainer>
  );
};

export default PreLoginHome;
